import { Logo } from "@/components/Logo";
import { useT } from "@/i18n";

export const AppHeader = () => {
  const { lang, setLang } = useT();
  return (
    <header className="sticky top-0 z-30 border-b border-[#C9A84C]/20 bg-[#f9f8f5]/95 backdrop-blur">
      <div className="relative mx-auto flex max-w-3xl items-center justify-center px-5 py-4">
        <a href="/" aria-label="Home">
          <Logo />
        </a>
        <div className="absolute right-4 top-1/2 flex -translate-y-1/2 items-center gap-1.5 text-xs font-medium tracking-wide">
          <button
            data-testid="lang-it"
            onClick={() => setLang("it")}
            className={`transition-colors ${lang === "it" ? "text-[#1a1a1a]" : "text-[#bcb4a4] hover:text-[#1a1a1a]"}`}
          >
            IT
          </button>
          <span className="text-[#dcd4c4]">/</span>
          <button
            data-testid="lang-en"
            onClick={() => setLang("en")}
            className={`transition-colors ${lang === "en" ? "text-[#1a1a1a]" : "text-[#bcb4a4] hover:text-[#1a1a1a]"}`}
          >
            EN
          </button>
        </div>
      </div>
    </header>
  );
};
